import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  RootState,
  getUserTenantId,
  isSysAdmin,
  setTenantFeatures,
  setTenantFeaturesLoading,
  store,
} from "../app";
import { defaultTenantFeatures, TenantFeaturesModel } from "../data/entities";
import { TenantService } from "../services";

const sysAdminRestrictionOverrides: Partial<TenantFeaturesModel> = {
  manageProviders: true,
  manageServiceTypes: true,
  manageLocationServices: true,
  managePricing: true,
};

export const useTenantFeatures = (): TenantFeaturesModel => {
  const dispatch = useDispatch();
  const sysAdmin = useSelector(isSysAdmin());
  const tenantId = useSelector(getUserTenantId());
  const features = useSelector((state: RootState) => state.tenantFeatures.features);

  useEffect(() => {
    if (!tenantId || tenantId < 0) return;
    if (store.getState().tenantFeatures.status !== 'idle') return;

    dispatch(setTenantFeaturesLoading());
    new TenantService()
      .getFeaturesAsync(tenantId)
      .then((result) => dispatch(setTenantFeatures(result)))
      .catch(() => dispatch(setTenantFeatures(null)));
  }, [dispatch, tenantId]);

  return useMemo(() => {
    const resolved = { ...defaultTenantFeatures, ...(features ?? {}) };
    return sysAdmin ? { ...resolved, ...sysAdminRestrictionOverrides } : resolved;
  }, [features, sysAdmin]);
};

export default useTenantFeatures;
